<template>
  <div class="text-white rounded-md mt-2">
    <div>
      <h1 class="text-2xl px-3 font-semibold">Добавление домов, улиц</h1>
      <div class="flex justify-between items-center my-4 px-3">
        <label class="text-sm">Улица <i class="required">*</i></label>
        <div class="w-[270px]">
          <customSelect
            v-model="streetCode"
            :options="streets"
            label="displayName"
            @onSelect="getSteets"
            placeholder="Улица"
            :search="true"
          ></customSelect>
        </div>
      </div>
      <button
        disabled
        class="border-solid border-[1px] border-white bg-white text-black px-2 py-1 rounded-[2px] ml-[120px]"
      >
        Редактор улиц
      </button>
      <div>
        <div class="flex justify-between items-center my-4 px-3">
          <label class="text-sm mr-4"
            >Номер дома <i class="required">*</i></label
          >
          <input
            ref="input"
            class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
            type="text"
            v-model="address.number"
          />
        </div>
        <div class="flex justify-between items-center my-4 px-3">
          <div class="text-sm mr-4">Координаты <i class="required">*</i></div>
          <input
            class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
            type="text"
            disabled
            v-model="coords"
          />
        </div>
        <button
          @click="dopInfoToHome = !dopInfoToHome"
          class="border-solid border-[1px] border-white bg-white text-black px-2 py-1 rounded-[2px] ml-[120px] hover:bg-slate-200"
        >
          Доп опции
        </button>
        <div v-if="dopInfoToHome">
          <div class="flex justify-between items-center my-4 px-3">
            <div class="text-sm mr-4">Владение</div>
            <input
              class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
              type="text"
              v-model="address.vladenie"
            />
          </div>
          <div class="flex justify-between items-center my-4 px-3">
            <div class="text-sm mr-4">Корпус</div>
            <input
              class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
              type="text"
              v-model="address.korpus"
            />
          </div>
          <div class="flex justify-between items-center my-4 px-3">
            <div class="text-sm mr-4">Cтроение</div>
            <input
              class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
              type="text"
              v-model="address.stroenie"
            />
          </div>
          <div class="flex justify-between items-center my-4 px-3">
            <div class="text-sm mr-4">Cооружения</div>
            <input
              class="border rounded w-[270px] text-sm text-black px-2 py-1 round h-[40px]"
              type="text"
              v-model="address.soorujenie"
            />
          </div>
        </div>
      </div>
      <div class="flex items-center my-6 px-3" v-if="error">
        <small class="text-red-600 mr-3 text-base">Такой дом существует</small>
        <div
          class="bg-white text-black rounded-sm p-1 cursor-pointer text-sm px-2 py-1"
        >
          Показать
        </div>
      </div>
      <div class="flex justify-between my-6 px-3">
        <button
          class="border-solid border-white border-[2px] bg-white text-black rounded-[8px] text-sm px-2 py-2"
          @click="close()"
        >
          Отмена
        </button>
        <button
          class="rounded-sm text-sm px-2 py-2"
          :class="isActive ? 'disabled' : 'nodisabled'"
          :disabled="isActive"
          @click="postAddresses"
        >
          Сохранить
        </button>
      </div>
    </div>
    <Loader :open="open" local />
  </div>
</template>

<script>
// import FormStreet from './FormStreet.vue'
import customSelect from "@/components/custom/customSelect/index.vue";
import Loader from "@/components/custom/customLoader/index.vue";
export default {
  props: ["village_id", "coor"],
  components: {
    customSelect,
    Loader,
  },
  data() {
    return {
      streets: [],
      open: false,
      streetCode: "",
      coords: "",
      address: {
        number: "",
        vladenie: "",
        korpus: "",
        stroenie: "",
        soorujenie: "",
        streetCode: "",
        lat: "",
        lng: "",
      },
      error: null,
      errorAdress: null,
      isActive: false,
      dopInfoToHome: false,
    };
  },
  methods: {
    close() {
      // this.$emit("addLocation");
      this.clearData();
    },
    getStreet() {
      this.$http
        .get(`v1/polygons/${this.village_id}/streets`)
        .then((res) => {
          this.streets = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clearData() {
      this.streetCode = "";
      this.coords = "";
      this.address = {
        number: "",
        vladenie: "",
        korpus: "",
        stroenie: "",
        soorujenie: "",
        streetCode: "",
        lat: "",
        lng: "",
      };
      this.error = null;
      this.errorAdress = null;
      this.isActive = false;
      this.dopInfoToHome = false;
      this.$emit("removeDeleteMarker");
    },
    getSteets(event) {
      this.address.streetCode = event.streetCode;
    },
    postAddresses() {
      this.open = true;
      this.$http
        .post("v1/points", this.address)
        .then((res) => {
          this.$toast.open({
            message: "Дом успешно добавлен",
            type: "success",
            position: "top",
          });
          this.clearData();
          this.$emit("createMarker", res.data);
        })
        .catch((error) => {
          this.$toast.open({
            message: error,
            type: "error",
            position: "top",
          });
          // if(err.response.data.errors.name == this.address.name) {
          //     this.error = true
          //     this.errorAdress = err.response.data.errors
          // }
        })
        .finally(() => {
          this.isActive = false;
          this.open = false;
        });
    },
  },
  watch: {
    coor() {
      if (this.coor) {
        this.address.lat = this.coor.substr(1, this.coor.indexOf(",") - 1);
        this.address.lng = this.coor.substring(
          this.coor.indexOf(",") + 1,
          this.coor.indexOf("]")
        );
        this.coords = `${this.address.lat}, ${this.address.lng}`;
      }
    },
  },
};
</script>

<style>
.round {
  border-radius: 7px;
}
input {
  height: 30px;
}
</style>
